import { CF_URLS } from '../config/api';

interface AdverseReactionPayload {
  name: string;
  email: string;
  product: string;
  reaction: string;
  onset: string;
  severity: string;
}

interface SubmitResult {
  success: boolean;
  reportId?: string;
  error?: string;
}

/**
 * Submit an adverse reaction report to Firestore via Cloud Function.
 * Falls back gracefully — caller should offer mailto if this fails.
 */
export async function submitAdverseReaction(payload: AdverseReactionPayload): Promise<SubmitResult> {
  const res = await fetch(CF_URLS.submitAdverseReaction, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload),
  });

  if (!res.ok) {
    const body = await res.json().catch(() => ({ error: 'Unknown error' }));
    return { success: false, error: body.error || `Server error (${res.status})` };
  }

  const data = await res.json();
  return { success: true, reportId: data.reportId };
}
